import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { variants } from '../../variants/variants';
import AttachmentNameDisplay from './AttachmentNameDisplay';

const FileUpload = ({
  handleFileChange,
  formik,
  name = 'attachment',
  buttonText = 'Upload File',
  fullWidth = false,
  accept = '*/*',
  multiple = true,
}) => {
  return (
    <>
      <Button
        fullWidth={fullWidth}
        variant="contained"
        component="label"
        startIcon={<CloudUploadIcon />}
        sx={{ borderRadius: '8px', backgroundColor: 'gray', fontSize: variants.fontSize.TEXT }}
      >
        {buttonText}
        <input
          type="file"
          name={name}
          hidden
          onChange={handleFileChange}
          onBlur={formik.handleBlur}
          multiple={multiple}
          accept={accept}
        />
      </Button>
      {formik.touched.attachment && formik.errors.attachment && (
        <Typography variant="body2" color="error" style={{ marginTop: '8px' }}>
          {formik.errors.attachment}
        </Typography>
      )}
      {!formik.errors.attachment && formik.values.attachment.length > 0 && (
        <AttachmentNameDisplay attachments={formik.values.attachment} />
      )}
    </>
  );
};

export default FileUpload;
